import { render, staticRenderFns } from "./SignoutScreen.vue?vue&type=template&id=dc10f35e"
import script from "./SignoutScreen.vue?vue&type=script&lang=js"
export * from "./SignoutScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports